<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <h2>{{$t('message.Statistic')}}</h2>
        <b-container>
          <b-row>
            <b-col md="6">
              <b-row>
                <div
                    class="col-md-4"
                    style="width: 500px;">
                  <Stat icon="bx bx-file" :title="$t('message.Bosh_ish')" :value="vacancies.total" />
                </div>
              </b-row>
            </b-col>
            <b-col md="6">
              <b-row>
                <div
                    class="col-md-4"
                    style="width: 500px;
                   margin-left: 68px;">
                  <Stat icon="bx bx-spreadsheet" :title="$t('message.Ariza_number')" :value="applications" />
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <b-row>
         <b-container>
        <StatsChart
            :applications="total"
            :accepted="acceptedApplications"
            :rejected="rejectedApplications" />
         </b-container>
        </b-row>
        <LineChart :byPosition="byPosition" />
      </div>
<!--      <RightBar />-->
    </div>
  </div>
</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import Stat from "@/components/widgets/stat";
import StatsChart from "./StatsChart";
import LineChart from "./LineChart";
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";
import {getSchoolReports} from "../../../../../../api/reports";

export default {
  name: "Statistics",
  components: {
    HorizontalTopbarInside,
    LineChart,
    StatsChart,
     SideBar,Stat,
  },
  data() {
    return {
      isMenuCondensed: false,
      statData: [
        {
          icon: "bx bx-file",
          title: this.$t('message.Vacancy'),
          value: "14",
        },
      ],
      dataStat: [
        {
          icon: "bx bx-archive-in",
          title: this.$t('message.Application_number'),
          value: "20",
        },
      ],
      vacancies: 0,
      applications: 0,
      acceptedApplications: 0,
      rejectedApplications: 0,
      total: 0,
      byPosition: [],
    };
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchSchoolReports()
  },
  methods: {
    fetchSchoolReports() {
      getSchoolReports().then(res => {
        this.vacancies = res.data.vacancies;
        this.applications = res.data.applications;
        this.total = this.vacancies.total;
        this.acceptedApplications = res.data.acceptedApplications;
        this.rejectedApplications = res.data.rejectedApplications;
        this.byPosition = res.data.byPosition;
      })
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #185d89;
}
.h-text{
  margin-top: 70px;
}
</style>



